import { memo } from 'react'
import DoctorProfileSidebar from 'components/doctorProfile/Sidebar/doctorProfileSidebar'

const AccountSidebar = () => {
  return <DoctorProfileSidebar />
}

AccountSidebar.whyDidYouRender = true

export default memo(AccountSidebar)